import moment from "moment";
import { DATE_FORMAT, SHOP_HOURS, TRAINING_HOURS } from "./constants";

export const getDateLabel = (date, increment = 0) => {
  const incrementDate = moment(date).add(increment, "day");
  return `${incrementDate.format("dd")} ${incrementDate.format(DATE_FORMAT)}`;
};

export const isNonJobTimeType = (timeType) =>
  timeType !== SHOP_HOURS && timeType !== TRAINING_HOURS;
